import { request } from './client';

export const apiGetCategories = () => request('/categories');
